import { Config } from "@/settings/Config";

export class ServerHelper {
  private static _config = new Config();

  public static getBaseUrl() {
    /*if (window.location.hostname === this._config.devServer.host) {
      // Local version
      return this._config.umbracoDevServer[this._config.portal].host;
    }*/
    return window.location.origin;
  }

  public static getBaseApiUrl() {
    /*if (window.location.hostname === this._config.devServer.host) {
      return this._config.umbracoDevServer[this._config.portal].host;
    }*/
    return window.location.origin;
  }

  public static getLocaleDataPath(platform: string, locale: string) {
    return `${this.getDataPath(platform)}/${locale}`;
  }

  public static getDataPath(platform: string) {
    return this._config.getDataPath(this._config.portal, platform);
  }
  
  public static getPortalPath() {
    return this._config.getPortalDataPath(this._config.portal);
  }
}